export enum TimeUnit {
  MINUTE = 60 * 1000,
  QUARTER_HOUR = 15 * 60 * 1000,
  HOUR = 60 * 60 * 1000,
  QUARTER_DAY = 6 * 60 * 60 * 1000,
  DAY = 24 * 60 * 60 * 1000,
  WEEK = 7 * 24 * 60 * 60 * 1000,
}

export const RELATIVE_TIME_RANGES = {
  LAST_24_HOURS: { lastNumDays: 1 },
  LAST_7_DAYS: { lastNumDays: 7 },
  LAST_30_DAYS: { lastNumDays: 30 },
};
